import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useAnalytics } from '@Shared/useAnalytics';
import { selectPurchaseDetails } from '@Header/Account/ducks/selectors';

const ReservationInProgressWrapper = styled.div`
  background-color: ${props => props.theme.carvana.gray.background};
  border-radius: 3px;
  padding: 10px 18px;
  width: 233px;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    width: 213px;
  }
`;

const Title = styled.div`
  color: ${props => props.theme.carvana.blue.dark};
  font-size: 12px;
  font-weight: 700;
  margin: 3px 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
`;

const Continue = styled.a`
  align-items: center;
  background-color: ${props => props.theme.carvana.blue.primary};
  border-radius: 3px;
  color: ${props => props.theme.carvana.white.primary};
  display: flex;
  font-size: 12px;
  font-weight: 700;
  height: 28px;
  justify-content: center;
  text-transform: uppercase;
  width: 100%;

  &:hover {
    background-color: ${props => props.theme.carvana.blue.hover};
    color: ${props => props.theme.carvana.white.primary};
  }
`;

const ReservationInProgressCard = ({
  reservation,
  className
}) => {
  const description = useMemo(() => `${reservation.year} ${reservation.make} ${reservation.model}`, [reservation]);
  const { trackEventAndGo } = useAnalytics();

  return (
    <ReservationInProgressWrapper className={className}>
      <Title data-cv-test="ReservedVehicleInfo">{description}</Title>
      <Continue
        data-cv-test="VdpReservationContinueButton"
        target="_self"
        href={`/vehicle/${reservation.vehicleId}`}
        onClick={e => trackEventAndGo(e, 'clicked reservation in progress card')}
      >
        Check Status
      </Continue>
    </ReservationInProgressWrapper>
  );
};

ReservationInProgressCard.defaultProps = {
  className: ''
};

ReservationInProgressCard.propTypes = {
  className: PropTypes.string,
  reservation: PropTypes.shape({
    year: PropTypes.number,
    make: PropTypes.string,
    model: PropTypes.string,
    orderState: PropTypes.string
  })
};

const mapStateToProps = state => ({
  reservation: selectPurchaseDetails(state).purchaseDetails
});

export default connect(mapStateToProps)(ReservationInProgressCard);
